/**
 * Hook für authentifizierte Bild-URLs.
 *
 * Browser-<img>-Tags senden keinen Authorization-Header.
 * Dieser Hook hängt den Supabase access_token als Query-Parameter an,
 * damit der Flask request_loader den User authentifizieren kann.
 */

import { useCallback } from 'react';
import { useSupabaseAuth } from '@/contexts/SupabaseAuthContext';

/**
 * Gibt eine Funktion zurück, die Bild-URLs mit Auth-Token versieht.
 *
 * Usage:
 *   const { authUrl } = useAuthImageUrl();
 *   <img src={authUrl(`/thumb/${id}`)} />
 */
export function useAuthImageUrl() {
  const { accessToken } = useSupabaseAuth();

  const authUrl = useCallback(
    (url: string): string => {
      if (!accessToken) return url;
      const separator = url.includes('?') ? '&' : '?';
      return `${url}${separator}token=${accessToken}`;
    },
    [accessToken],
  );

  return { authUrl };
}
